<h1 mat-dialog-title>Asset Streams</h1>
<div mat-dialog-content>
    <p>
        <b>{{ data.asset.name }}</b> belongs to the following Streams:
    </p>
    <mat-list>
        @for (stream of data.streams; track stream) {
            <mat-list-item>
                <mat-icon matListItemIcon>water</mat-icon>
                <div mat-line>{{ stream.name }}</div>
                <div mat-line>{{ stream.description }}</div>
            </mat-list-item>
        }
    </mat-list>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
</div>
